import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export interface FeedbackData {
  userId?: string;
  username: string;
  email: string;
  feedback: string;
}

export interface Feedback {
  _id: string;
  userId?: string;
  username: string;
  email: string;
  feedback: string;
  timestamp: string;
  status: 'new' | 'reviewed' | 'resolved';
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedResponse {
  success: boolean;
  feedback: Feedback[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
  stats?: {
    total: number;
    new: number;
    reviewed: number;
    resolved: number;
  };
}

class FeedbackService {
  // Submit feedback
  static async submitFeedback(data: FeedbackData) {
    try {
      console.log('📤 Submitting feedback:', data);
      const response = await axios.post(`${API_URL}/api/feedback`, data, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log('✅ Feedback submitted successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Error submitting feedback:', error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        throw error.response.data;
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
        throw { error: 'No response from server. Please check your connection.' };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Request setup error:', error.message);
        throw { error: error.message };
      }
    }
  }

  // Get all feedback (admin only)
  static async getAllFeedback(page = 1, limit = 10, status?: string, search?: string) {
    try {
      const token = localStorage.getItem('token');
      const config: any = {
        params: {
          page,
          limit,
          ...(status && { status }),
          ...(search && { search })
        }
      };

      if (token) {
        config.headers = {
          'Authorization': `Bearer ${token}`
        };
      }

      const response = await axios.get(`${API_URL}/api/feedback`, config);
      return response.data;
    } catch (error: any) {
      console.error('Error fetching feedback:', error);
      throw error.response?.data || { error: 'Failed to fetch feedback' };
    }
  }
}

export default FeedbackService;